<template>
  <div class="home">
  <q-page class="flex flex-center">
    <table class="logo">
        <tr>
            <td>
                <img alt="SH logo" src="../assets/img/escudo-1.svg" class="img-responsive" />
            </td>
            <td>Sistema de<br />Control de<br />Personal</td>
        </tr>
    </table>
  </q-page>
  </div>
</template>

<style scoped>
table.logo {
   font-family: 'GothamBook';
    font-size: 35px;
    font-weight: bold;
    color: #c90166;
}

    table.logo td {
        padding: 5px 5px;
        height: 30px;
    }

        table.logo td img {
            width: 150px;
        }


</style>